import AllBonusesPage from './AllBonusesPage';

export default AllBonusesPage;
